
import * as ipxRuntime$wvQ6PU5TdD from 'D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 320,
    "md": 600,
    "lg": 1024,
    "xl": 1400,
    "xxl": 1536,
    "2xl": 1440
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "d1myjizz7y6887.cloudfront.net",
    "halebop-shop.electra.se",
    "testhalebop-shop.electra.se",
    "stagehalebop-shop.electra.se"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$wvQ6PU5TdD, defaults: {"maxAge":259200,"baseURL":"/shop/_ipx"} }
}
        